import { type PublicCollectionItem } from "@/services/collection/item/public";
import { isMyNick } from "@/services/user";
import { type Ref } from "vue";

export function useIsMyItem(collectionItem: Ref<PublicCollectionItem | undefined>) {
  return computed(() => {
    if (collectionItem.value === undefined) {
      return false;
    }

    const ownerNickname = collectionItem.value.collectorNickname;
    return isMyNick(ownerNickname);
  });
}
